import React from 'react'

import { useNavigate } from 'react-router-dom';
export default function SHEQPage() {
    const navigate = useNavigate();
    const [isAppMenuOpen, setIsAppMenuOpen] = React.useState(false);
    
    const [formData, setFormData] = React.useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        safetyServices: [],
        safetyTraining: [],
        healthServices: [],
        healthProducts: [],
        supplements: {},
        topicalProducts: {},
        nutritionalProducts: {},
        firstAidProducts: {},
        environmentServices: [],
        qualityServices: [],
        message: ''
    });
    
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [submitSuccess, setSubmitSuccess] = React.useState(false);
    const [submitError, setSubmitError] = React.useState(null);

    const safetyOptions = [
        'ISO 45001 – Occupational Health & Safety Management Systems implementation',
        'Contractor management',
        'Safety Consulting Services',
        'Safety File Compilation & Management',
        'Online Safety Management Systems coordination',
        'Risk Assessments Development',
        'Method Statements & Safe Work Procedures',
        'Emergency Evacuation Planning',
        'Fire Risk Assessments & Fire Safety Audits',
        'Incident Investigation & Reporting',
        'SHEQ Audits & Inspections',
        'Mobile Equipment Fire Suppression Audits',
        'Safety Culture & Leadership Programmes',
        'HSEC Online® & Passport 360 Compliance Management'
    ];

    const safetyTrainingOptions = [
        'Yellow machine operator training',
        'First aid training',
        'Firefighting training',
        'HIRA (Hazard Identification & Risk Assessment)',
        'First Aid Training',
        'Basic Fire Fighting',
        'Working at Heights',
        'Contractor Safety Induction',
        'Defensive / Safe Driving Training',
        'Hand & Power Tool Safety',
        'Lifting & Rigging',
        'Lock-Out / Tag-Out (LOTO) Awareness',
        'Confined Space Awareness',
        'Safety Leadership Training',
        'Supervisor Safety Training',
        'Behaviour Based Safety Awareness',
        'Occupational Health & Hygiene Awareness',
        'Induction Training Coordination'
    ];

    const healthServicesOptions = [
        'ISO 45001 – Occupational Health & Safety Management Systems implementation',
        'Occupational Health Coordination',
        'Medical Surveillance Coordination',
        'Pre-Employment & Exit Medical Coordination',
        'First Aid Programme Coordination',
        'Employee Wellness Awareness Programmes'
    ];

    const healthProductsOptions = [
        'Omega 3 Capsules',
        'Repellent Mosquito Spray',
        'Muscle Cooling Gel',
        'Shower Gel',
        'SPF 50',
        'Repellent Mosquito Cream',
        'Cooling Gel',
        'Food Sock',
        'Multivitamins',
        'Energy Bars',
        'Shakes Protein'
    ];

    const environmentServicesOptions = [
        'ISO 14001 – Environmental Management Systems implementation',
        'Environmental Management Support',
        'Environmental Risk Assessments',
        'Spill Response Planning and products',
        'Environmental Awareness Programmes'
    ];

    const qualityServicesOptions = [
        'ISO 9001 – Quality Management Systems implementation',
        'Quality Management Support',
        'Compliance Tracking Systems',
        'Internal Audits & Inspection Support',
        'Corrective Action Management',
        'Operational Procedure Development'
    ];

    const supplementOptions = [
        { name: 'Vitamin A', desc: 'Eye & Skin Health', filename: 'Vit A' },
        { name: 'Vitamin B-Complex', desc: 'Energy & Vitality', filename: 'B-COMPLEX' },
        { name: 'Vitamin C', desc: 'Immune Support', filename: 'VIT C' },
        { name: 'Vitamin D', desc: 'Immune Support & Calcium Absorption', filename: 'VIT D' },
        { name: 'Calcium', desc: 'Bone Health', filename: 'CALCIUM' },
        { name: 'Zinc', desc: 'Immune & Healing Support', filename: 'ZINC' },
        { name: 'Omega 3', desc: 'Brain Support', filename: 'OMEGA 3' },
        { name: 'Probiotics', desc: 'Gut Health', filename: 'PROBIOTICS' },
        { name: 'Uri-Support', desc: 'Urinary & Bladder Support', filename: 'URI SUPPORT' },
        { name: 'Collagen Powder', desc: 'Skin, Joint & Hair Support', filename: 'COLLAGEN POWDER' },
        { name: 'Charcoal', desc: 'Digestive Support', filename: 'CHARCOAL' },
        { name: 'Alkaline Powder', desc: 'pH & Digestive Balance', filename: 'ALKALINE POWDER' }
    ];

    const topicalOptions = [
        { name: 'Herbal Muscle Gel / Cooling Arnica Gel', desc: 'Muscle & Joint Relief', filename: 'HERBALMUSCLE GEL' },
        { name: 'Muscle Cream', desc: 'Muscle & Joint Care', filename: 'HERBAL MUSCLE CREAM' },
        { name: 'Mosquito Spray', desc: 'Insect Protection', filename: 'MOSQUITO SPRAY' },
        { name: 'Mosquito Cream', desc: 'Insect Protection', filename: 'MOSQUITO CREAM' },
        { name: 'SPF50', desc: 'Sun Protection', filename: 'SUNSCREEN SPF 50' },
        { name: 'Tissue Oil', desc: 'Skin Repair & Hydration', filename: 'TISSUE OIL' },
        { name: 'Shower Gel Aloe Vera', desc: 'Gentle Hydrating Cleanser', filename: 'ALOE VERA SHOWER GEL' },
        { name: 'Body Lotion Aloe Vera', desc: 'Daily Skin Hydration', filename: 'ALOE VERA BODY LOTION' },
        { name: 'Wound Spray', desc: 'First Aid & Healing Support', filename: 'WOUND SPRAY' },
        { name: 'Wound Cream', desc: 'Advanced Healing Support', filename: 'WOUND CREAM' },
        { name: 'HOCL Spray', desc: 'Antimicrobial Skin & Wound Care', filename: 'HOCL SPRAY' }
    ];

    const nutritionalOptions = [
        { name: 'Nutritional Products Maize Meal Porridge', desc: 'Nutrient-rich fortified maize meal porridge provides sustained energy with essential micronutrients', filename: 'MAIZE MEAL PORRIDGE' },
        { name: 'Maize Energy Shake', desc: 'High protein shake for muscle recovery and prolonged satiety', filename: 'MAIZE ENERGY SHAKE' },
        { name: 'Electrolyte Sachets', desc: 'Enhances hydration, supports muscle function and prevents cramps', filename: 'ELECTROLYTE SACHETS' },
        { name: 'Maize Meal Porridge 25kg Bulk', desc: 'Bulk fortified maize meal for sustained energy', filename: 'MAIZE MEAL PORRIDGE 25G' }
    ];

    const firstAidOptions = [
        { name: 'Emergency Eye Rinse Station', desc: 'Minimizes eye injury severity with on-the-spot decontamination', filename: 'EMERGENCE EYE RINSE STATION' },
        { name: 'Fabric Plasters', desc: 'Flexible fabric plasters for minor cuts and grazes', filename: 'FABRIC PLASTERS' },
        { name: 'Waterproof Plasters', desc: '100% moisture barrier plasters for active lifestyles', filename: 'WATERPROOF PLASTERS' }
    ];

    const handleCheckboxChange = (section, value) => {
        setFormData(prev => {
            const currentArray = prev[section];
            if (currentArray.includes(value)) {
                return {
                    ...prev,
                    [section]: currentArray.filter(item => item !== value)
                };
            } else {
                return {
                    ...prev,
                    [section]: [...currentArray, value]
                };
            }
        });
    };

    const handleSupplementToggle = (name) => {
        setFormData(prev => {
            const newSupplements = { ...prev.supplements };
            if (newSupplements.hasOwnProperty(name)) {
                delete newSupplements[name];
            } else {
                newSupplements[name] = 50;
            }
            return { ...prev, supplements: newSupplements };
        });
    };

    const handleSupplementQtyChange = (name, delta) => {
        setFormData(prev => {
            if (!prev.supplements.hasOwnProperty(name)) return prev;
            const current = prev.supplements[name];
            return { ...prev, supplements: { ...prev.supplements, [name]: Math.max(50, current + delta) } };
        });
    };

    const handleTopicalToggle = (name) => {
        setFormData(prev => {
            const newTopicals = { ...prev.topicalProducts };
            if (newTopicals.hasOwnProperty(name)) {
                delete newTopicals[name];
            } else {
                newTopicals[name] = 50;
            }
            return { ...prev, topicalProducts: newTopicals };
        });
    };

    const handleTopicalQtyChange = (name, delta) => {
        setFormData(prev => {
            if (!prev.topicalProducts.hasOwnProperty(name)) return prev;
            const current = prev.topicalProducts[name];
            return { ...prev, topicalProducts: { ...prev.topicalProducts, [name]: Math.max(50, current + delta) } };
        });
    };

    const handleNutritionalToggle = (name) => {
        setFormData(prev => {
            const newNutritional = { ...prev.nutritionalProducts };
            if (newNutritional.hasOwnProperty(name)) {
                delete newNutritional[name];
            } else {
                newNutritional[name] = 50;
            }
            return { ...prev, nutritionalProducts: newNutritional };
        });
    };

    const handleNutritionalQtyChange = (name, delta) => {
        setFormData(prev => {
            if (!prev.nutritionalProducts.hasOwnProperty(name)) return prev;
            const current = prev.nutritionalProducts[name];
            return { ...prev, nutritionalProducts: { ...prev.nutritionalProducts, [name]: Math.max(50, current + delta) } };
        });
    };

    const handleFirstAidToggle = (name) => {
        setFormData(prev => {
            const newFirstAid = { ...prev.firstAidProducts };
            if (newFirstAid.hasOwnProperty(name)) {
                delete newFirstAid[name];
            } else {
                newFirstAid[name] = 50;
            }
            return { ...prev, firstAidProducts: newFirstAid };
        });
    };

    const handleFirstAidQtyChange = (name, delta) => {
        setFormData(prev => {
            if (!prev.firstAidProducts.hasOwnProperty(name)) return prev;
            const current = prev.firstAidProducts[name];
            return { ...prev, firstAidProducts: { ...prev.firstAidProducts, [name]: Math.max(50, current + delta) } };
        });
    };

    // Helper function to construct image paths for SHEQ products
    const getSheqImagePath = (filename) => {
        // Ensure the filename is URL-encoded and uses the correct extension
        return `images/SHEQ-IMAGES/${encodeURIComponent(filename)}.jpeg`;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError(null);

        try {
            const response = await fetch('/api/submit_sheq.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to submit form');
            }

            setSubmitSuccess(true);
            // Reset form after successful submission
            setFormData({
                name: '',
                company: '',
                email: '',
                phone: '',
                safetyServices: [],
                safetyTraining: [],
                healthServices: [],
                healthProducts: [],
                supplements: {},
                topicalProducts: {},
                nutritionalProducts: {},
                firstAidProducts: {},
                environmentServices: [],
                qualityServices: [],
                message: ''
            });
        } catch (error) {
            setSubmitError(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const CheckboxGroup = ({ title, options, section }) => (
        <div className="mb-6">
            <h3 className="text-lg font-bold text-gray-900 mb-3">{title}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {options.map((option, index) => (
                    <label key={index} className="flex items-start space-x-2 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={formData[section].includes(option)}
                            onChange={() => handleCheckboxChange(section, option)}
                            className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-700">{option}</span>
                    </label>
                ))}
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <img 
                                src="images/logo/MM Logo.jpg" 
                                alt="Logo" 
                                className="h-9 w-9 rounded-lg cursor-pointer shadow-sm border border-gray-200" 
                                onClick={() => navigate('/')}
                            />
                            <div>
                                <h1 className="text-2xl font-black text-gray-900 tracking-tighter uppercase leading-none">SHEQ Services</h1>
                                <p className="text-[10px] text-blue-600 font-bold uppercase tracking-[0.2em] mt-1">Safety, Health, Environment & Quality</p>
                                <button 
                                    onClick={() => navigate('/')}
                                    className="mt-2 text-sm text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-1"
                                >
                                    <i className="fas fa-arrow-left"></i>
                                    Back to Home
                                </button>
                            </div>
                        </div>
                        <button 
                            onClick={() => setIsAppMenuOpen(true)} 
                            className="p-2 text-gray-900 hover:text-blue-600 transition-colors"
                        >
                            <i className="fas fa-bars text-xl"></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* App Navigation Sidebar (Slide-in) */}
            {isAppMenuOpen && (
                <div className="fixed inset-0 z-[100] flex justify-end">
                    <div className="absolute inset-0 bg-black/30 transition-opacity" onClick={() => setIsAppMenuOpen(false)}></div>
                    <div className="relative w-4/5 max-w-[400px] bg-white h-full shadow-2xl flex flex-col transform transition-transform duration-300 animate-slide-in-right overflow-hidden border-l border-gray-200">
                        <div className="p-4 border-b flex justify-between items-center bg-white sticky top-0 z-10">
                            <h2 className="text-lg font-bold text-gray-900">Application Menu</h2>
                            <button onClick={() => setIsAppMenuOpen(false)} className="text-gray-900 p-2"><i className="fas fa-times text-2xl"></i></button>
                        </div>
                        <div className="p-4 overflow-y-auto flex-grow space-y-2">
                            <button onClick={() => { navigate('/'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-home w-6"></i> Home</button>
                            <button onClick={() => { navigate('/equipment'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-truck-monster w-6"></i> Equipment</button>
                            <button onClick={() => { navigate('/consumables'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-box-open w-6"></i> Consumables</button>
                            <button onClick={() => { navigate('/miscellaneous'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-circle-notch w-6"></i> Miscellaneous</button>
                            <button onClick={() => { navigate('/rebuilds'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-tools w-6"></i> Rebuilds</button>
                            <button onClick={() => { navigate('/rentals'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-clock w-6"></i> Rentals</button>
                            <button onClick={() => { navigate('/commercial'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-briefcase w-6"></i> Commercial</button>
                            <button onClick={() => { navigate('/components-and-spares'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-cogs w-6"></i> Components</button>
                            <button onClick={() => { navigate('/financeform'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-green-600 font-bold transition-colors w-full text-left"><i className="fas fa-hand-holding-usd w-6"></i> Financing</button>
                            <button onClick={() => { navigate('/sheq'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg bg-blue-50 text-blue-600 font-bold transition-colors w-full text-left"><i className="fas fa-shield-alt w-6"></i> SHEQ Services</button>
                            <button onClick={() => { navigate('/drill-catalog'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg bg-orange-50 text-orange-600 font-bold transition-colors w-full text-left"><i className="fas fa-drill w-6"></i> Drill Catalog</button>
                            <button onClick={() => { navigate('/kp-insurance'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-red-600 font-bold transition-colors w-full text-left"><i className="fas fa-crown w-6"></i> King Price</button>
                            <button onClick={() => { navigate('/labour'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-green-600 font-bold transition-colors w-full text-left"><i className="fas fa-users w-6"></i> Labour</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Form */}
            <div className="container mx-auto px-4 py-8">
                <div className="max-w-4xl mx-auto">
                    {submitSuccess ? (
                        <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center">
                            <i className="fas fa-check-circle text-5xl text-green-500 mb-4"></i>
                            <h2 className="text-2xl font-bold text-green-800 mb-2">Thank You!</h2>
                            <p className="text-green-700">Your SHEQ inquiry has been submitted successfully. We will contact you shortly.</p>
                            <button 
                                onClick={() => setSubmitSuccess(false)}
                                className="mt-6 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                            >
                                Submit Another Inquiry
                            </button>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-8">
                            {/* Recommended Supplier (SlascanH Holdings) */}
                            <div className="mb-8">
                                <div className="flex items-center gap-2 mb-3">
                                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
                                    <span className="text-[12px] font-black text-gray-900 uppercase tracking-tighter">Recommended Supplier</span>
                                </div>
                                <a
                                    href="https://slascanh.co.za/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-4 bg-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow w-fit"
                                >
                                    <img
                                        src="images/home/SLASCANH-Logo.png"
                                        alt="SlascanH Holdings Logo"
                                        className="h-32 object-contain"
                                    />
                                    <div>
                                        <p className="text-lg font-bold text-gray-900">SlascanH Holdings</p>
                                        <p className="text-sm text-blue-600 font-medium flex items-center gap-1">
                                            Visit Website <i className="fas fa-external-link-alt"></i>
                                        </p>
                                    </div>
                                </a>
                            </div>

                            {submitError && (
                                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                                    <p className="text-red-700">{submitError}</p>
                                </div>
                            )}

                            {/* Contact Information */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">Contact Information</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
                                        <input
                                            type="text"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Safety Services */}
                            <CheckboxGroup 
                                title="Safety Services" 
                                options={safetyOptions} 
                                section="safetyServices" 
                            />

                            {/* Safety Training */}
                            <CheckboxGroup 
                                title="Safety Training" 
                                options={safetyTrainingOptions} 
                                section="safetyTraining" 
                            />

                            {/* Health Services */}
                            <CheckboxGroup 
                                title="Health Services" 
                                options={healthServicesOptions} 
                                section="healthServices" 
                            />

                            {/* Health Products */}
                            <CheckboxGroup 
                                title="Health Products" 
                                options={healthProductsOptions} 
                                section="healthProducts" 
                            />

                            {/* Supplements with Counters */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">Supplements (Bulk Order - Min 50 units)</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {supplementOptions.map((option, index) => {
                                        const isSelected = formData.supplements.hasOwnProperty(option.name);
                                        const quantity = formData.supplements[option.name] || 0;
                                        
                                        return (
                                            <div key={index} className={`p-4 border rounded-xl transition-all ${isSelected ? 'border-blue-500 bg-blue-50/30' : 'bg-gray-50 border-gray-200'}`}>
                                                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                                    <div className="flex items-center gap-4 flex-1">
                                                        <label className="flex items-center space-x-3 cursor-pointer flex-1">
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelected}
                                                                onChange={() => handleSupplementToggle(option.name)}
                                                                className="mt-1 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                            />
                                                            <div className="flex-shrink-0 bg-white p-1 rounded-lg border border-gray-100 shadow-sm">
                                                                <img 
                                                                    src={getSheqImagePath(option.filename)}
                                                                    alt={option.name}
                                                                    className="w-12 h-12 object-contain"
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = 'images/logo/MM - Logo.jpeg'; console.error(`Failed to load SHEQ image: ${e.target.src}`); }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <span className="text-sm font-bold text-gray-900">{option.name}</span>
                                                                <p className="text-xs text-gray-500 italic mt-0.5">{option.desc}</p>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    
                                                    {isSelected && (
                                                        <div className="flex items-center gap-4 bg-white border border-gray-200 rounded-lg px-4 py-2 shadow-sm animate-fade-in self-end sm:self-auto">
                                                            <button type="button" onClick={() => handleSupplementQtyChange(option.name, -1)} className="text-blue-600 hover:text-blue-800 disabled:opacity-30 text-lg" disabled={quantity <= 50}><i className="fas fa-minus-circle"></i></button>
                                                            <span className="text-sm font-black w-8 text-center text-gray-900">{quantity}</span>
                                                            <button type="button" onClick={() => handleSupplementQtyChange(option.name, 1)} className="text-blue-600 hover:text-blue-800 text-lg"><i className="fas fa-plus-circle"></i></button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Topical Products */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">Topical Products (Bulk Order - Min 50 units)</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {topicalOptions.map((option, index) => {
                                        const isSelected = formData.topicalProducts.hasOwnProperty(option.name);
                                        const quantity = formData.topicalProducts[option.name] || 0;

                                        return (
                                            <div key={index} className={`p-4 border rounded-xl transition-all ${isSelected ? 'border-blue-500 bg-blue-50/30' : 'bg-gray-50 border-gray-200'}`}>
                                                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                                    <div className="flex items-center gap-4 flex-1">
                                                        <label className="flex items-center space-x-3 cursor-pointer flex-1">
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelected}
                                                                onChange={() => handleTopicalToggle(option.name)}
                                                                className="mt-1 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                            />
                                                            <div className="flex-shrink-0 bg-white p-1 rounded-lg border border-gray-100 shadow-sm">
                                                                <img 
                                                                    src={getSheqImagePath(option.filename)}
                                                                    alt={option.name}
                                                                    className="w-12 h-12 object-contain"
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = 'images/logo/MM - Logo.jpeg'; console.error(`Failed to load SHEQ image: ${e.target.src}`); }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <span className="text-sm font-bold text-gray-900">{option.name}</span>
                                                                <p className="text-xs text-gray-500 italic mt-0.5">{option.desc}</p>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    
                                                    {isSelected && (
                                                        <div className="flex items-center gap-4 bg-white border border-gray-200 rounded-lg px-4 py-2 shadow-sm animate-fade-in self-end sm:self-auto">
                                                            <button type="button" onClick={() => handleTopicalQtyChange(option.name, -1)} className="text-blue-600 hover:text-blue-800 disabled:opacity-30 text-lg" disabled={quantity <= 50}><i className="fas fa-minus-circle"></i></button>
                                                            <span className="text-sm font-black w-8 text-center text-gray-900">{quantity}</span>
                                                            <button type="button" onClick={() => handleTopicalQtyChange(option.name, 1)} className="text-blue-600 hover:text-blue-800 text-lg"><i className="fas fa-plus-circle"></i></button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Nutritional Products */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">Nutritional Products (Bulk Order - Min 50 units)</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {nutritionalOptions.map((option, index) => {
                                        const isSelected = formData.nutritionalProducts.hasOwnProperty(option.name);
                                        const quantity = formData.nutritionalProducts[option.name] || 0;
                                        
                                        return (
                                            <div key={index} className={`p-4 border rounded-xl transition-all ${isSelected ? 'border-blue-500 bg-blue-50/30' : 'bg-gray-50 border-gray-200'}`}>
                                                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                                    <div className="flex items-center gap-4 flex-1">
                                                        <label className="flex items-center space-x-3 cursor-pointer flex-1">
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelected}
                                                                onChange={() => handleNutritionalToggle(option.name)}
                                                                className="mt-1 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                            />
                                                            <div className="flex-shrink-0 bg-white p-1 rounded-lg border border-gray-100 shadow-sm">
                                                                <img 
                                                                    src={getSheqImagePath(option.filename)}
                                                                    alt={option.name}
                                                                    className="w-12 h-12 object-contain"
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = 'images/logo/MM - Logo.jpeg'; console.error(`Failed to load SHEQ image: ${e.target.src}`); }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <span className="text-sm font-bold text-gray-900">{option.name}</span>
                                                                <p className="text-xs text-gray-500 italic mt-0.5">{option.desc}</p>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    
                                                    {isSelected && (
                                                        <div className="flex items-center gap-4 bg-white border border-gray-200 rounded-lg px-4 py-2 shadow-sm animate-fade-in self-end sm:self-auto">
                                                            <button type="button" onClick={() => handleNutritionalQtyChange(option.name, -1)} className="text-blue-600 hover:text-blue-800 disabled:opacity-30 text-lg" disabled={quantity <= 50}><i className="fas fa-minus-circle"></i></button>
                                                            <span className="text-sm font-black w-8 text-center text-gray-900">{quantity}</span>
                                                            <button type="button" onClick={() => handleNutritionalQtyChange(option.name, 1)} className="text-blue-600 hover:text-blue-800 text-lg"><i className="fas fa-plus-circle"></i></button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* First Aid Products */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">First Aid Products (Bulk Order - Min 50 units)</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {firstAidOptions.map((option, index) => {
                                        const isSelected = formData.firstAidProducts.hasOwnProperty(option.name);
                                        const quantity = formData.firstAidProducts[option.name] || 0;

                                        return (
                                            <div key={index} className={`p-4 border rounded-xl transition-all ${isSelected ? 'border-blue-500 bg-blue-50/30' : 'bg-gray-50 border-gray-200'}`}>
                                                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                                    <div className="flex items-center gap-4 flex-1">
                                                        <label className="flex items-center space-x-3 cursor-pointer flex-1">
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelected}
                                                                onChange={() => handleFirstAidToggle(option.name)}
                                                                className="mt-1 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                            />
                                                            <div className="flex-shrink-0 bg-white p-1 rounded-lg border border-gray-100 shadow-sm">
                                                                <img 
                                                                    src={getSheqImagePath(option.filename)}
                                                                    alt={option.name}
                                                                    className="w-12 h-12 object-contain"
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = 'images/logo/MM - Logo.jpeg'; console.error(`Failed to load SHEQ image: ${e.target.src}`); }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <span className="text-sm font-bold text-gray-900">{option.name}</span>
                                                                <p className="text-xs text-gray-500 italic mt-0.5">{option.desc}</p>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    
                                                    {isSelected && (
                                                        <div className="flex items-center gap-4 bg-white border border-gray-200 rounded-lg px-4 py-2 shadow-sm animate-fade-in self-end sm:self-auto">
                                                            <button type="button" onClick={() => handleFirstAidQtyChange(option.name, -1)} className="text-blue-600 hover:text-blue-800 disabled:opacity-30 text-lg" disabled={quantity <= 50}><i className="fas fa-minus-circle"></i></button>
                                                            <span className="text-sm font-black w-8 text-center text-gray-900">{quantity}</span>
                                                            <button type="button" onClick={() => handleFirstAidQtyChange(option.name, 1)} className="text-blue-600 hover:text-blue-800 text-lg"><i className="fas fa-plus-circle"></i></button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Environment Services */}
                            <CheckboxGroup 
                                title="Environment Services" 
                                options={environmentServicesOptions} 
                                section="environmentServices" 
                            />

                            {/* Quality Services */}
                            <CheckboxGroup 
                                title="Quality Services" 
                                options={qualityServicesOptions} 
                                section="qualityServices" 
                            />

                            {/* Additional Message */}
                            <div className="mb-6">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Additional Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    rows="4"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Any additional information or requirements..."
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="px-8 py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
